__turbopack_context__.v({
  "className": "orbitron_3e176d54-module__j_fzGG__className",
});
